import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router-dom"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"
import dealService from "@irati/deals/services/deals"
import history from "@irati/utils/history"
import checkoutService from "@irati/checkout/services/checkout"
import redemptionFlow from "@irati/checkout/utils/redemption"
import detailsToWebAddress from "@irati/checkout/utils/redemption/helpers/detailsToWebAddress"

interface Props extends RouteComponentProps<{urlSlug: string, checkoutId: string}> {}

const PaymentRedirectLanding: React.FC<Props> = (props, context) => {
  const {urlSlug, checkoutId} = props.match.params
  const [load, setLoad] = useState(hangPromise())

  useEffect(() => {
    const request = dealService.getDealByUrlSlug({urlSlug}).then((deal) => {
      return checkoutService.getCheckout(checkoutId).then((checkout) => {
        return redemptionFlow.paymentComplete(deal, checkoutId, checkout.paymentOrder.uuid).then((details) => {
          const url = detailsToWebAddress(details)
          history.push(url, context)
          return hangPromise()
        })
      })
    })
    setLoad(request)
  }, [])

  return <Loading load={load} />
}

PaymentRedirectLanding.contextTypes = {
  appPath: PropTypes.string
}

export default PaymentRedirectLanding
